module.exports = __webpack_public_path__ + "media/images/talent/flow03-d1016f90c3150442622a508d7b177043.png";